'use client';

import Link from 'next/link';

import NoticeSlideItemStyled from './NoticeSlideItem.styled';

interface NoticeSildeItemProps {
  sequence: number;
  category: string;
  subject: string;
  date: string;
}

const NoticeSildeItem = ({ sequence, category, subject, date }: NoticeSildeItemProps) => {
  return (
    // <Link href="/support/notice/list" passHref>
    <Link
      href={{
        pathname: '/support/notice/list',
        query: { sequence: sequence },
      }}
      passHref
      legacyBehavior
    >
      <NoticeSlideItemStyled.NoticeContainer>
        <NoticeSlideItemStyled.CategoryCell>[{category}]</NoticeSlideItemStyled.CategoryCell>
        <NoticeSlideItemStyled.SubjectCell>{subject}</NoticeSlideItemStyled.SubjectCell>
        <NoticeSlideItemStyled.DateCell>{date}</NoticeSlideItemStyled.DateCell>
      </NoticeSlideItemStyled.NoticeContainer>
    </Link>
  );
};

export default NoticeSildeItem;
